<script>
	import { modals, closeModal } from '$lib/modal-store';
	import { fade } from 'svelte/transition';

	/** @type {Array<{component: any, props: any, preventStackReduce?: boolean, uncloseable?: boolean}>} */
	let modalStack = $state([]);

	$effect(() => {
		modalStack = $modals;
	});

	/** @param {number} index*/
	function handleBackdropClick(index) {
		const currentModal = modalStack[index];
		if (currentModal.uncloseable) return;
		
		for (let i = modalStack.length - 1; i >= index; i--) {
			if (!modalStack[i].uncloseable) {
				closeModal();
			}
		}
	}

	/** @param {number} index */
	function getModalStyle(index) {
		const zIndex = 1001 + index * 2;
		const modal = modalStack[index];
		const nextModal = modalStack[index + 1];
		const isTopModal = index === modalStack.length - 1;
		const shouldScale = !isTopModal && !nextModal?.preventStackReduce && !modal.preventStackReduce;
		const scale = shouldScale ? 0.95 : 1;
		return `z-index: ${zIndex}; transform: scale(${scale});`;
	}
</script>

{#each modalStack as modal, index}
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<!-- svelte-ignore a11y_no_static_element_interactions -->
	<div
		class="modal-backdrop pointer-events-auto {modal.uncloseable ? 'bg-black/40 backdrop-blur-md' : 'bg-black/20'}"
		onclick={() => handleBackdropClick(index)}
		transition:fade={{ duration: 300 }}
		style="z-index: {1000 + index * 2};"
	>
		<div class="modal-content" onclick={(e) => e.stopPropagation()} style={getModalStyle(index)}>
			<modal.component {...modal.props} />
		</div>
	</div>
{/each}

<style>
	.modal-backdrop {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.modal-content {
		transition: transform 0.3s ease;
		pointer-events: none;
		width: 100%;
		height: 100%;
	}
</style>
